import PropTypes from 'prop-types'
import { useEffect, useRef, useState } from 'react'
import { handleDuplicateArray } from '../../helpers/common'
import { Z_INDEX } from '../../utils/common'
import { Checkbox } from '../html/checkbox'
import { Element } from '../html/element'
import { Icon } from '../html/icon'
import { TextEllipsisStaticLine } from '../textEllipsis/TextEllipsisStaticLine'
import { getAllIdChildren, getAllIdItem, handleName } from './helper'
import classes from './index.module.scss'

const timeoutCheckDoubleClick = 350

const TreeItem = ({
  item,
  itemDetail,
  nameKey,
  levelKey,
  isParentOpen,
  doubleClickItem,
  isSearchAbsolute,
  idKey,
  listChecked,
  setListChecked,
  isActiveSelected,
  isHaveCheckbox,
  listHightlight,
  isCheckedWhenClickText,
  listDisabled,
  isSortKey,
  sortKey,
  isReopen,
  itemDefaultOpen,
  isTextEllipsis,
  lineClamp,
  disabledCheckDbClick,
  onClickItem,
  isLevel1,
  disableCheckClick,
}) => {
  const pRef = useRef()
  const isDoubleClick = useRef(false)

  const [isOpen, setIsOpen] = useState(false)
  const [idsItem, setIdsItem] = useState([])
  const [isChecked, setIsCheck] = useState(false)
  const [keys, setKeys] = useState([])
  const [isHightlight, setIsHightlight] = useState(false)

  useEffect(() => {
    setIsHightlight(listHightlight.includes(item[idKey]))
  }, [listHightlight])

  useEffect(() => {
    setKeys(
      isSortKey
        ? Object.keys(item.children).sort()
        : sortKey
        ? Object.keys(item.children).sort((id1, id2) => {
            return item.children[id1][sortKey] - item.children[id2][sortKey]
          })
        : Object.keys(item.children),
    )
  }, [])

  useEffect(() => {
    if (isHaveCheckbox) {
      setIdsItem(getAllIdItem(item, idKey, item?.exceptChildren))
    }
  }, [])

  useEffect(() => {
    if (isHaveCheckbox) {
      if (
        idsItem.length > 0 &&
        idsItem.every((id) => listChecked.includes(id))
      ) {
        setIsCheck(true)
      } else if (
        idsItem.length > 0 &&
        idsItem.some((id) => listChecked.includes(id))
      ) {
        setIsCheck(-1)
      } else {
        setIsCheck(false)
      }
    }
  }, [listChecked, idsItem])

  useEffect(() => {
    if (
      itemDefaultOpen &&
      getAllIdChildren(item, idKey)?.some((id) => itemDefaultOpen.includes(id))
    ) {
      setIsOpen(true)
    } else if (itemDetail.isOpen) {
      setIsOpen(true)
    } else {
      setIsOpen(false)
    }
  }, [isReopen])

  const handleClick = () => {
    if (disabledCheckDbClick) {
      if (onClickItem) {
        onClickItem(item)
      }
      setIsOpen(!isOpen)
    } else {
      setTimeout(() => {
        if (!isDoubleClick.current) setIsOpen(!isOpen)
      }, timeoutCheckDoubleClick)
    }
    if (isCheckedWhenClickText && Object.keys(item.children)?.length === 0) {
      handleChangeCheckbox({ target: { checked: !isChecked } })
    }
  }

  const handleDoubleClick = () => {
    if (doubleClickItem) {
      isDoubleClick.current = true
      doubleClickItem(item)
      setTimeout(() => {
        isDoubleClick.current = false
      }, timeoutCheckDoubleClick + 50)
    }
  }

  const handleChangeCheckbox = (checked) => {
    if (isHaveCheckbox) {
      if (checked) {
        setListChecked(handleDuplicateArray(listChecked.concat(idsItem)))
      } else {
        setListChecked(
          handleDuplicateArray(
            listChecked.filter((id) => !idsItem.includes(id)),
          ),
        )
      }
    }
  }

  if (!isParentOpen || !itemDetail.isDisplay) {
    return <></>
  }
  return (
    <Element elementName="li" className={classes.li}>
      <Element
        ref={pRef}
        onDoubleClick={
          !listDisabled[item?.[idKey]] ? handleDoubleClick : undefined
        }
        style={{
          color:
            isHightlight || (isActiveSelected && isChecked)
              ? '#2f9aee'
              : 'inherit',
        }}
        onClick={handleClick}
      >
        <Element className="dFlex">
          {isHaveCheckbox && (
            <Element elementName="label" className={classes.labelCheckbox}>
              <Checkbox
                onChange={handleChangeCheckbox}
                checked={isChecked}
                allowChange={!disableCheckClick}
              />
            </Element>
          )}
          <Element className={`dFlex alignItemsCenter w100 gap1`}>
            <Element
              className={`${isLevel1 ? 'flex1 minW0' : classes.liTextFit} ${
                listDisabled[item[idKey]] ? classes.disabled : ''
              }`}
            >
              {isTextEllipsis && !item.isNotTextEllipsis ? (
                <TextEllipsisStaticLine
                  lineClamp={lineClamp}
                  isI18n={false}
                  text={handleName(item, nameKey, levelKey)}
                  zIndexTooltip={Z_INDEX.MODAL + 1}
                />
              ) : (
                handleName(item, nameKey, levelKey)
              )}
            </Element>
            <Icon
              className={`${
                keys.length === 0
                  ? 'dNone'
                  : isLevel1
                  ? isOpen
                    ? 'icon-caret-bottom'
                    : 'icon-caret-right'
                  : isOpen
                  ? 'icon-arrow-bottom'
                  : 'icon-arrow-right'
              }`}
              style={{
                color: isLevel1 ? '#3A414B' : '#9C9C9C',
                fontSize: isLevel1 ? 8 : 10,
              }}
            />
          </Element>
        </Element>
      </Element>
      {keys.length > 0 && (
        <Element elementName="ul" className={classes.ul}>
          {keys.map((key) => (
            <TreeItem
              item={item.children[key]}
              itemDetail={itemDetail.children[key]}
              nameKey={nameKey}
              levelKey={levelKey}
              isParentOpen={isOpen}
              key={key}
              doubleClickItem={doubleClickItem}
              isSearchAbsolute={isSearchAbsolute}
              idKey={idKey}
              listChecked={listChecked}
              setListChecked={setListChecked}
              isActiveSelected={isActiveSelected}
              isHaveCheckbox={isHaveCheckbox}
              listHightlight={listHightlight}
              isCheckedWhenClickText={isCheckedWhenClickText}
              listDisabled={listDisabled}
              isSortKey={isSortKey}
              sortKey={sortKey}
              isReopen={isReopen}
              itemDefaultOpen={itemDefaultOpen}
              isTextEllipsis={isTextEllipsis}
              lineClamp={lineClamp}
              disabledCheckDbClick={disabledCheckDbClick}
              onClickItem={onClickItem}
              disableCheckClick={disableCheckClick}
            />
          ))}
        </Element>
      )}
    </Element>
  )
}

TreeItem.propTypes = {
  item: PropTypes.object.isRequired,
  itemDetail: PropTypes.object.isRequired,
  nameKey: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  isParentOpen: PropTypes.bool.isRequired,
  doubleClickItem: PropTypes.func,
  isSearchAbsolute: PropTypes.bool,
  idKey: PropTypes.string,
  levelKey: PropTypes.string,
  listChecked: PropTypes.array,
  setListChecked: PropTypes.func,
  isActiveSelected: PropTypes.bool,
  isHaveCheckbox: PropTypes.bool,
  listHightlight: PropTypes.array,
  isCheckedWhenClickText: PropTypes.bool,
  sortKey: PropTypes.string,
  isReopen: PropTypes.bool.isRequired,
  isTextEllipsis: PropTypes.bool,
  lineClamp: PropTypes.number,
  isLevel1: PropTypes.bool,
}

TreeItem.defaultProps = {
  isActiveSelected: false,
  isHaveCheckbox: false,
  isCheckedWhenClickText: false,
  isTextEllipsis: true,
  lineClamp: 1,
  isLevel1: false,
}

export default TreeItem
